import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const contactPersonPermissionsK = {
  showPictureStoreLink: "contact_person_permissions.showPictureStoreLink",
  viewPriceList: "contact_person_permissions.viewPriceList",
  showDekoSupportLink: "contact_person_permissions.showDekoSupportLink",
  viewProjects: "contact_person_permissions.viewProjects",
  viewInvoice: "contact_person_permissions.viewInvoice",
  manageOtherPublicUser: "contact_person_permissions.manageOtherPublicUser",
};

export const useContactPersonPermissionsT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      showPictureStoreLink: t(contactPersonPermissionsK.showPictureStoreLink),
      viewPriceList: t(contactPersonPermissionsK.viewPriceList),
      showDekoSupportLink: t(contactPersonPermissionsK.showDekoSupportLink),
      viewProjects: t(contactPersonPermissionsK.viewProjects),
      viewInvoice: t(contactPersonPermissionsK.viewInvoice),
      manageOtherPublicUser: t(contactPersonPermissionsK.manageOtherPublicUser),
    }),
    [i18n.language]
  );
};